console.log("Cart vTwo");

let cartDrawerContent = document.querySelectorAll(".cart-loop");

//Clear Cart
const clearCart = function () {
  cartDrawerContent.forEach(function (item) {
    item.innerHTML = "";
  });
};


//Cart Count
const countCartItems = function (cart) {
  //console.log(cart);

  let cartCounters = document.querySelectorAll(".cart-count");

  cartCounters.forEach(function (item) {
    item.innerText = cart.item_count;
  });

  //Get Currency
  let symbol = window.currencySymbol || "$";

  //Cart Total No Discounts
  let cartTotal = document.querySelectorAll(".cart-total");

  let totalPrice = cart.original_total_price / 100;

  let formatted = totalPrice.toFixed(2);
  if (formatted.endsWith(".00")) {
    formatted = parseInt(formatted, 10);
  }
  let formatTotal = `${symbol}${formatted}`;

  cartTotal.forEach(function (item) {
    item.innerText = formatTotal;
    item.dataset.orderTotalNoDiscounts = parseInt(totalPrice);
  });

  let memberTotalBlock = document.querySelector("#member-total-block");

  if(memberTotalBlock){
    if(cart.original_total_price == cart.total_price){
      memberTotalBlock.classList.remove("show");
    } else {
      memberTotalBlock.classList.add("show");
    }
  }

  //Cart Discounts
  let totalSavingsCon = document.querySelector("#total-savings");
  let totalDiscount = cart.total_discount / 100;
  let intTotalDiscount = parseFloat(totalDiscount);
  if(intTotalDiscount == 0){
    if(totalSavingsCon){
      totalSavingsCon.innerText = "-";
    }
  } else {
    let formatted = intTotalDiscount.toFixed(2);
    if (formatted.endsWith(".00")) {
      formatted = parseInt(formatted, 10);
    }
    let formatOrderSavings = `${symbol}${formatted}`;
    if(totalSavingsCon){
      totalSavingsCon.innerText = "- " + formatOrderSavings;
    }
  }
  //Cart Order Total
  let orderTotalCon = document.querySelector("#order-total");
  let totalOrder = (cart.total_price / 100).toFixed(2);
  if (totalOrder.endsWith(".00")) {
    totalOrder = parseInt(totalOrder, 10);
  }
  if(orderTotalCon){
    orderTotalCon.innerText = `${symbol}${totalOrder}`;
  }


};

//Render Cart
const renderCart = function (cart) {
  //console.log(cart);

  let memberStatus = document.querySelector("#side-cart").dataset.status;

  //Reset Total Savings
  let totalSavingsCon = document.querySelector("#total-savings");
  if(totalSavingsCon){
    totalSavingsCon.dataset.totalSavings = 0;
  }

  let orderTotalCon = document.querySelector("#order-total");
  if(orderTotalCon){
    orderTotalCon.dataset.orderTotal = 0;
  }

  let memberSavingsCon = document.querySelector("#member-savings");
  if(memberSavingsCon){
    memberSavingsCon.dataset.memberSavings = 0;
  }

  let cartMemberUpsellBlockCheck = document.querySelector("#cart-member-upsell");

  if (cartMemberUpsellBlockCheck) {
    cartMemberUpsellBlockCheck.dataset.essentials = "false";
    cartMemberUpsellBlockCheck.classList.remove("active");
  }

  //console.log(memberStatus);

  cart.items.forEach(function (item, index) {
    //console.log(item);

    //Image
    let pImage =
      '<a href="' + item.url + '"><img src="' + item.image + '"/></a>';

    //Price
    let pPrice = "";
    let symbol = window.currencySymbol || "$";

    //console.log(symbol);

    let pSavings = item.total_discount / 100;

    let originalPrice = item.original_line_price / 100;
    let discountPrice = item.line_price / 100;

    let formatted = originalPrice.toFixed(2);

    if (formatted.endsWith(".00")) {
      formatted = parseInt(formatted, 10);
    }
    let formatOriginalPrice = `${symbol}${formatted}`;


    if(discountPrice < originalPrice){
      let formatted = discountPrice.toFixed(2);
      if (formatted.endsWith(".00")) {
        formatted = parseInt(formatted, 10);
      }
      let formatDiscountPrice = `${symbol}${formatted}`;
      pPrice = '<p class="price ag"><s>' + formatOriginalPrice + "</s>" + formatDiscountPrice +"</p>";
    } else {
      pPrice = '<p class="price ag">' + formatOriginalPrice + "</p>";
    }

    //Title
    let trimTitle = item.product_title.split(" - ");
    let pTitle = '<p class="title ag"><a href="' + item.url + '">' + trimTitle[0] + '<span class="final-sale"></span></a></p>';

    //Notifications
    let pNotification = '<p class="type ag"></p>';

    //Color
    let pColor = "";

    if (item.handle == "membership-program-yearly-recurring" || item.handle == "membership-program-non-recurring" || item.handle == "membership-program-complimentary" || item.handle == "pay-now-to-unlock-free-returns" || item.handle == "complimentary-membership-non-recurring" ||trimTitle[1] == null) {
      pColor = "";
    } else {
      if (trimTitle[1]) {
        pColor = '<p class="color ag">Color: ' + trimTitle[1] + "</p>";
      } else {
        pColor = "";
      }
    }

    //Size
    let sizeCheck = item.options_with_values[0].value.toString();
    let pSize = "";

    if (sizeCheck == "Default Title") {
      pSize = "";
    } else {
      pSize = '<p class="size ag">Size: ' + sizeCheck + "</p>";
    }

    //Quantity
    let pQuantity = "";

    if (item.handle == "pay-now-to-unlock-free-returns") {
    } else {
      pQuantity = '<p class="quantity ag">Quantity: ' + item.quantity + "</p>";
    }

    //Remove
    let pRemove = '<a class="remove-btn ag" href="#">Remove</a>';
    //let pRemove = '<p>' + cartVars.removeFromCartNoDot + '</p>';

    let pPreOrder = '';
    let preOrderNote = item.properties['Note'];

    if(preOrderNote != "" && preOrderNote != undefined){
      pPreOrder = '<span class="pre-order ag grey">' + preOrderNote + '</span>';
    }
    
    let pReturnPolicy = "";
    let returnPolicyNote = item.properties["Return Policy"];

    if (returnPolicyNote != "" && returnPolicyNote != undefined) {
      pReturnPolicy = '<span class="return-policy ag grey">' + returnPolicyNote + "</span>";
    }

    //Right Side of Product
    let pInfo = '<li class="item" data-sale-savings="0" data-discount-savings="' + pSavings + '" data-line="' + Number(index + 1) + '" data-qty="' + item.quantity + '">' + '<div class="left">' + pImage + "</div>" + '<div class="right">' + pNotification + pTitle + pPrice + '<div class="variants"></div>' + pColor + pSize + pQuantity + pPreOrder + pReturnPolicy + pRemove + "</div></li>";

    cartDrawerContent.forEach(function (ctem) {
      ctem.innerHTML = ctem.innerHTML + pInfo;
    });

    //Tags
    let dirtyName = "/products/" + item.handle + ".js";

    var xhr = new XMLHttpRequest();
    xhr.open("GET", dirtyName, true);
    xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

    xhr.onload = function () {
      if (xhr.status >= 200 && xhr.status < 400) {
        let product = JSON.parse(xhr.responseText);
        let cartLoop = document.querySelector("#side-cart");
        //console.log(product);

        let onSale = false;
        let finalSale = false;
        let qtyDirty = cartLoop.querySelectorAll(".quantity")[index].innerText;
        let match = qtyDirty.match(/\d+/);
        let qty = parseInt(match[0]);
        let comparePrice = product.compare_at_price * qty;
        let productPrice = product.price * qty;
        let splitFull;

        let memberStatus = cartLoop.dataset.memberStatus;
        let isMember = false;
        let hasEssentials = false;
        let pTags = product.tags;

        if (memberStatus == "member") {
          isMember = true;
        }

        pTags.forEach(function (tag) {
          let tagString = tag.toString();
          if (
            tagString.includes("essentials") ||
            tagString.includes("exclusives")
          ) {
            hasEssentials = true;
          }
        });

        if (comparePrice > productPrice) {
          onSale = true;
          //console.log(product.title + " is on sale");
        }

        if (onSale) {
          let savings = ((comparePrice - productPrice) / comparePrice) * 100;
          if (savings >= 69) {
            finalSale = true;
          }

          let fullPrice = Shopify.formatMoney(comparePrice);
          splitFull = fullPrice.split(".");

          let salePrice = Shopify.formatMoney(productPrice);
          let splitSale = salePrice.split(".");
          cartLoop.querySelectorAll(".price")[index].innerHTML =
            "<s>" + splitFull[0] + "</s>" + splitSale[0];
          cartLoop.querySelectorAll("li")[index].dataset.saleSavings =
            (comparePrice - productPrice) / 100;
        }

        if (hasEssentials) {
          let cartMemberUpsellBlock = document.querySelector("#cart-member-upsell");

          if (cartMemberUpsellBlock) {
            cartMemberUpsellBlock.classList.add("active");
            cartMemberUpsellBlock.dataset.essentials = "true";
          } 

          //Set Member Savings
          let currentProductPrice = (product.price / 100) * 0.2;
          let intCurrentProductPrice = parseInt(currentProductPrice);

          let currentMemberSavings =
            document.querySelector("#member-savings").dataset.memberSavings;
          let intCurrentMemberSavings = parseInt(currentMemberSavings);

          let newMemberSavings =
            intCurrentProductPrice + intCurrentMemberSavings;
          document.querySelector("#member-savings").dataset.memberSavings =
            newMemberSavings;
          document.querySelector("#member-savings").innerText =
            "$" + newMemberSavings;
          // console.log(newMemberSavings);
        }

        pTags.forEach(function (tag) {
          let tagString = tag.toString();
          if (tagString.includes("essentials")) {
            if (finalSale) {
              cartLoop.querySelectorAll(".type")[index].innerHTML =
                "Essentials -  Final Sale";
            } else {
              cartLoop.querySelectorAll(".type")[index].innerHTML =
                "Essentials";
            }
          } else if (finalSale) {
            cartLoop.querySelectorAll(".type")[index].innerHTML = "Final Sale";
          }

          if (tagString.includes("pre-order")) {
            //cartLoop.querySelectorAll(".type")[index].innerHTML = "Pre-Order";
          }
        });
      }
    };

    xhr.send();

  });

  cartDrawerContent.forEach(function (rtem) {
    let removeBtn = rtem.querySelectorAll(".remove-btn");
    removeBtn.forEach(function (stem, s) {
      stem.addEventListener("click", function (event) {
        event.preventDefault();
        let line = this.parentNode.parentNode.getAttribute("data-line");
        //console.log(line);
        let currentIndexer = s;
        changeItem(line, currentIndexer);
      });
    });
  });

  let cartMemberUpsellBlock = document.querySelector("#cart-member-upsell");

  if(cartMemberUpsellBlock){
    if (cartMemberUpsellBlock.dataset.essentials == "false") {
      cartMemberUpsellBlock.classList.remove("active");
    }
  }

};

//Post Cart Check
const postCartCheck = function (cart) {
  //console.log(cart);
  let memberStatus = document.querySelector("#side-cart").dataset.status;

  let tempMemberCheck = false;
  let upsellCon = document.querySelectorAll(".upsell");

  cart.items.forEach(function (item) {
    if (
      item.handle == "membership-program-non-recurring" ||
      item.handle == "membership-program-yearly-recurring" ||
      item.handle == "complimentary-membership-non-recurring"
    ) {
      tempMemberCheck = true;
    }
  });

  if (tempMemberCheck) {
    console.log("Is temp member")
    cart.items.forEach(function (item, i) {
      let dirtyName = "/products/" + item.handle + ".js";

      var xhr = new XMLHttpRequest();
      xhr.open("GET", dirtyName, true);
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 400) {
          let product = JSON.parse(xhr.responseText);
          //console.log(product);
          let cartLoop = document.querySelector("#side-cart");
          let pTags = product.tags;
          let isEssential = false;

          pTags.forEach(function (tag) {
            let tagString = tag.toString();
            if (
              tagString.includes("essentials") ||
              tagString.includes("exclusives")
            ) {
              isEssential = true;
            }
          });

          if (isEssential) {

          }
        }
      };

      xhr.send();
    });

    upsellCon.forEach(function (ktem) {
      ktem.classList.add("hide");
    });
  } else {
    upsellCon.forEach(function (ktem) {
      ktem.classList.remove("hide");
    });
    if (memberStatus == "member") {
      //console.log("Is Member");

      cart.items.forEach(function (item, i) {
        let dirtyName = "/products/" + item.handle + ".js";

        var xhr = new XMLHttpRequest();
        xhr.open("GET", dirtyName, true);
        xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

        xhr.onload = function () {
          if (xhr.status >= 200 && xhr.status < 400) {
            let product = JSON.parse(xhr.responseText);
            //console.log(product);
            let cartLoop = document.querySelector("#side-cart");
            let pTags = product.tags;
            let isEssential = false;

            pTags.forEach(function (tag) {
              let tagString = tag.toString();
              if (
                tagString.includes("essentials") ||
                tagString.includes("exclusives")
              ) {
                isEssential = true;
              }
            });

            if (isEssential) {
            }
          }
        };

        xhr.send();
      });
    } else {
      //console.log("Not Member");

      cart.items.forEach(function (item, i) {
        let dirtyName = "/products/" + item.handle + ".js";

        var xhr = new XMLHttpRequest();
        xhr.open("GET", dirtyName, true);
        xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

        xhr.onload = function () {
          if (xhr.status >= 200 && xhr.status < 400) {
            let product = JSON.parse(xhr.responseText);
            //console.log(product);
            //console.log(i);
            let cartLoop = document.querySelectorAll(".cart-loop li");
            let pTags = product.tags;
            let isEssential = false;

            pTags.forEach(function (tag) {
              let tagString = tag.toString();
              if (
                tagString.includes("essentials") ||
                tagString.includes("exclusives")
              ) {
                isEssential = true;
              }
            });

            if (isEssential) {

            }
          }
        };

        xhr.send();
      });
    }
  }
};

//Display Cart in Side Cart
const displayCart = function () {
  var xhr = new XMLHttpRequest();
  xhr.open("GET", "/cart.js", true);
  xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

  xhr.onload = function () {
    if (xhr.status >= 200 && xhr.status < 400) {
      var cartData = JSON.parse(xhr.responseText);

      clearCart();
      countCartItems(cartData);
      renderCart(cartData);
      postCartCheck(cartData);
    }
  };

  xhr.send();
};


//Change Quantity
const changeItem = function (line, callback) {
  let quantity = 0;
  var xhr = new XMLHttpRequest();
  xhr.open("POST", "/cart/change.js", true);
  xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");

  xhr.onload = function () {
    if (xhr.status >= 200 && xhr.status < 400) {
      var cartData = JSON.parse(xhr.responseText);
      countCartItems(cartData);
      if (typeof callback === "function") {
        callback(cartData);
      } else {
        clearCart();
        displayCart();
      }
    }
  };

  xhr.send("quantity=" + quantity + "&line=" + line);
};

displayCart();

document.addEventListener("la:dn:cart:discounted", function (event) {
  const discountedCart = event.detail.data[0];
  //console.log("Discount applied to the cart", discountedCart);
  //console.log(discountedCart.subtotal.discount);
  if(discountedCart.subtotal.discount > 0){
    displayCart();
  }
});